// Types
import type ComparablesModelType from '../models/Comparables';
import type AddressModelType from '../models/Address';

type BoundingRectType = {
  northLat: number | null;
  southLat: number | null;
  eastLng: number | null;
  westLng: number | null;
};

// San Francisco Bounding box fallback
const SFDefault: BoundingRectType = {
  northLat: 37.8334643499866,
  southLat: 37.65972099481182,
  eastLng: -122.0841735127774,
  westLng: -122.86900932820708,
};

export const useBoundingRect = (userProperty: AddressModelType, comparables: Array<ComparablesModelType>) => {
  const boundingRect: BoundingRectType = {
    northLat: userProperty.lat ?? SFDefault.northLat,
    southLat: userProperty.lat ?? SFDefault.southLat,
    eastLng: userProperty.lon ?? SFDefault.eastLng,
    westLng: userProperty.lon ?? SFDefault.westLng,
  };

  if (comparables) {
    comparables.forEach((comp) => {
      boundingRect.northLat =
        (boundingRect.northLat && comp.lat && Math.max(boundingRect.northLat, comp.lat)) || SFDefault.northLat;
      boundingRect.southLat =
        (boundingRect.southLat && comp.lat && Math.min(boundingRect.southLat, comp.lat)) || SFDefault.southLat;
      boundingRect.eastLng =
        (boundingRect.eastLng && comp.lon && Math.max(boundingRect.eastLng, comp.lon)) || SFDefault.eastLng;
      boundingRect.westLng =
        (boundingRect.westLng && comp.lon && Math.min(boundingRect.westLng, comp.lon)) || SFDefault.westLng;
    });
  }

  return [boundingRect];
};
